// @flow

import styled from "styled-components";
import { fontNormal } from "@fdr/static-ui/Typography";
import buildColor from "@fdr/static-ui/ColorPalette";

import ButtonDefault from "../../_atoms/ButtonDefault";

export const RunnerInfoContainer = styled.section`
  @media screen and (max-width: 320px) {
    margin-left: 18px;
  }

  @media screen and (min-width: 321px) {
    margin-left: 56px;
  }
`;

export const PastRacesError = styled.div`
  padding: 19px 0;
  display: flex;
  align-items: center;
  font-family: ${fontNormal};
  font-size: 12px;
  color: ${buildColor("grey", "900")};
`;

export const RetryButton = styled(ButtonDefault)`
  margin-left: 8px;
  font-family: ${fontNormal};
  font-size: 12px;
  color: ${buildColor("blue", "500")};
`;

export const RunnerRatingTagContainer = styled.div`
  padding: 8px 0;
  border-top: 1px solid ${buildColor("grey", "300")};

  & > div {
    display: inline-flex;
  }
`;
